import { useHistory } from "react-router-dom";

import SegmentedToggle from "components/shared/SegmentedToggle";

import styles from "./LoginTypeSelector.module.scss";

export const LOGIN_TYPE_SSO = "sso";
export const LOGIN_TYPE_EMAIL = "email";

export type LoginType = typeof LOGIN_TYPE_SSO | typeof LOGIN_TYPE_EMAIL;

interface LoginTypeSelectorProps {
  value: LoginType;
  onChange: (value: LoginType) => void;
  className?: string;
}

export default function LoginTypeSelector({
  value,
  onChange,
  className
}: LoginTypeSelectorProps) {
  const history = useHistory();

  const handleChange = (selectedValue: string | number) => {
    const newValue = selectedValue as LoginType;
    onChange(newValue);

    // Add fade-out class to container
    const container = document.querySelector(".loginTransitionContainer");
    if (container) {
      // Change height class after fade starts
      setTimeout(() => {
        if (newValue === LOGIN_TYPE_SSO) {
          container.classList.remove("emailHeight");
          container.classList.add("ssoHeight");
        } else {
          container.classList.remove("ssoHeight");
          container.classList.add("emailHeight");
        }
      }, 100);
    }

    // Navigate after height transition completes
    setTimeout(() => {
      if (newValue === LOGIN_TYPE_SSO && value === LOGIN_TYPE_EMAIL) {
        history.push("/sso");
      } else if (newValue === LOGIN_TYPE_EMAIL && value === LOGIN_TYPE_SSO) {
        history.push("/login");
      }
    }, 500);
  };

  return (
    <SegmentedToggle
      height={45}
      data-testid="login-type-segmented-select"
      className={`${styles.loginSelector} ${styles[className] || ""}`}
      value={value}
      options={[
        { label: "Sign in with Email", value: LOGIN_TYPE_EMAIL },
        { label: "Sign in with SSO", value: LOGIN_TYPE_SSO }
      ]}
      onChange={handleChange}
      block
    />
  );
}
